import { useEffect, useState, FormEvent } from 'react';
import type { Occasion } from '@lr/shared';
import { apiFetch } from '../../lib/api';

export function AdminOccasions() {
  const [rows, setRows] = useState<Occasion[]>([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);

  function load() {
    apiFetch<Occasion[]>('/api/admin/occasions')
      .then(setRows)
      .finally(() => setLoading(false));
  }
  useEffect(load, []);

  return (
    <>
      <div className="admin-page-head">
        <div>
          <h1>Occasions</h1>
          <div className="sub">
            Tag pieces by use-case (e.g. Wedding, Smart-casual, Festival).
          </div>
        </div>
        <div className="actions">
          <button className="btn-primary" onClick={() => setShowCreate(true)}>
            + Add occasion
          </button>
        </div>
      </div>

      <div className="a-card">
        {loading ? (
          <div className="a-empty">Loading…</div>
        ) : rows.length === 0 ? (
          <div className="a-empty">
            <div className="h">No occasions yet</div>
            <div className="p">Customers filter by occasion when browsing.</div>
            <button className="btn-primary" onClick={() => setShowCreate(true)}>
              + Add occasion
            </button>
          </div>
        ) : (
          <div className="a-table-wrap">
            <table className="a-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Slug</th>
                  <th style={{ width: 100 }}>Sort</th>
                  <th style={{ width: 100 }}>Active</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((o) => (
                  <tr key={o.id}>
                    <td style={{ fontWeight: 600 }}>{o.name}</td>
                    <td className="id">{o.slug}</td>
                    <td className="num">{o.sort_order}</td>
                    <td>
                      {o.is_active ? (
                        <span className="badge badge-good">Active</span>
                      ) : (
                        <span className="badge badge-neutral">Hidden</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showCreate && (
        <CreateModal
          onClose={(created) => {
            setShowCreate(false);
            if (created) load();
          }}
        />
      )}
    </>
  );
}

function CreateModal({ onClose }: { onClose: (created?: boolean) => void }) {
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [sortOrder, setSortOrder] = useState('0');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const finalSlug = slug || name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      await apiFetch('/api/admin/occasions', {
        method: 'POST',
        body: JSON.stringify({
          name,
          slug: finalSlug,
          sort_order: Number(sortOrder) || 0
        })
      });
      onClose(true);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed');
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <div className="a-modal-overlay open" onClick={() => onClose()} />
      <aside className="a-modal open">
        <form onSubmit={onSubmit} style={{ display: 'contents' }}>
          <div className="a-modal-head">
            <h2>New occasion</h2>
            <button type="button" className="btn-ghost" onClick={() => onClose()}>
              ×
            </button>
          </div>
          <div className="a-modal-body">
            {error && <div className="a-alert a-alert-error">{error}</div>}
            <div className="a-form">
              <div className="a-field">
                <label>Name *</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="a-field">
                <label>Slug</label>
                <input
                  type="text"
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                  placeholder="auto-generated"
                />
              </div>
              <div className="a-field">
                <label>Sort order</label>
                <input
                  type="number"
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="a-modal-foot">
            <button type="button" className="btn-secondary" onClick={() => onClose()}>
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Saving…' : 'Create'}
            </button>
          </div>
        </form>
      </aside>
    </>
  );
}
